import React from 'react';
import styles from './LeaguesCard.module.scss';

/* ───────────────────────────────── component ── */
const LeaguesCard = React.forwardRef(({ league, onSelect }, ref) => (
  <div className={styles.leagueSingle} >
    <button
      ref={ref}
      tabIndex={0}
      aria-label={league.name}
      className={styles.leagueItem}
      onClick={onSelect}
      /* default background */
      style={{ backgroundImage: `url(${league.defaultLogo})` }}
      data-default={league.defaultLogo}
      data-hover={league.logo}
      /* swap on focus / hover */
      onFocus={e => (e.currentTarget.style.backgroundImage = `url(${league.logo})`)}
      onBlur={e  => (e.currentTarget.style.backgroundImage = `url(${league.defaultLogo})`)}
    />
  </div>
));
LeaguesCard.displayName = 'LeaguesCard';

/* ───────────────────────────── comparison ──
   Re-render only when:
   • league identity changes     (id)
   • either logo URL changes     (visual)
   • handler reference changes   (unlikely)                          */
const areEqualLeague = (prev, next) =>
  prev.league.id           === next.league.id &&
  prev.league.defaultLogo  === next.league.defaultLogo &&
  prev.league.logo         === next.league.logo &&
  prev.onSelect            === next.onSelect;

/* ───────────────────────────── export ── */
export default React.memo(LeaguesCard, areEqualLeague);